export enum VideoTypeEnum {
  Embedded = 1,
  Uploaded = 2,
}
